// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-skeleton {\n  border: 1px solid #e6e6e6;\n  border-radius: 6px;\n}\n.card-skeleton header {\n  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);\n  background-size: 400% 100%;\n  animation: ant-skeleton-loading 1.4s ease infinite;\n  box-shadow: 0 0 black;\n  height: 213px;\n}\n.card-skeleton .card-skeleton-body {\n  padding: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
